import { render, staticRenderFns } from "./IconSvgCheck.vue?vue&type=template&id=98a4fc3c&scoped=true&"
import script from "./IconSvgCheck.vue?vue&type=script&lang=js&"
export * from "./IconSvgCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a4fc3c",
  null
  
)

export default component.exports